/**
 * Tool-row model for `label_raster` modules: Brush / Eraser choose what is
 * written, Fill is a modifier that applies the chosen one to a whole connected
 * region, Pick stands alone. The combinations map onto the viewer's `fill`
 * (brush + Fill) and `erase_fill` (eraser + Fill) tool states.
 */
import type { LabelRasterTool } from "@frontend/pages/case-workspace/pathology/types"
import {
  isLabelRasterFillTool,
  type LabelRasterToolBase,
  labelRasterToolBase,
  withLabelRasterFillMode
} from "@virdx/wsi-viewer"

/** Buttons in the panel's tool row. */
export type LabelRasterToolItem = LabelRasterToolBase | "fill"

/** Whether a tool-row button renders pressed for the current tool. */
export function isLabelRasterToolItemPressed(item: LabelRasterToolItem, tool: LabelRasterTool | null): boolean {
  if (!tool) return false
  if (item === "fill") return isLabelRasterFillTool(tool)
  return labelRasterToolBase(tool) === item
}

/** Next tool after clicking a tool-row item (a pressed brush / eraser / pick deselects; Fill toggles the modifier). */
export function nextLabelRasterTool(item: LabelRasterToolItem, tool: LabelRasterTool | null): LabelRasterTool | null {
  const base = tool ? labelRasterToolBase(tool) : null
  const fillMode = tool ? isLabelRasterFillTool(tool) : false
  if (item === "fill") {
    if (fillMode && base && base !== "pick") return base
    return withLabelRasterFillMode(base === "erase" ? "erase" : "brush", true)
  }
  if (base === item) return null
  if (item === "pick") return "pick"
  return withLabelRasterFillMode(item, fillMode)
}
